import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

const styles = StyleSheet.create({
  bodyContainer: {
    maxWidth: 320,
  },
  itemContainer: {
    marginTop: spacing.$4,
  },
  subtitleContainer: {
    flexDirection: 'row',
  },
});

const createBox = (baseStyle: BoxProps['style']) => ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [baseStyle, style] });

export const BodyContainer = createBox(styles.bodyContainer);

export const ItemContainer = createBox(styles.itemContainer);

export const SubtitleContainer = createBox(styles.subtitleContainer);
